
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M8.396 10.8A5.398 5.398 0 0013.8 5.396C13.796 2.46 11.34.004 8.404 0A5.398 5.398 0 003 5.404c.004 2.936 2.46 5.392 5.396 5.396zm-.165-8.996a3.603 3.603 0 013.765 3.765A3.612 3.612 0 018.57 8.996a3.603 3.603 0 01-3.765-3.765A3.612 3.612 0 018.23 1.804zM5.04 13.2c.548 0 1.436.6 3.36.6 1.939 0 2.445-.758 3.36-.758s2.723 1.084 3.221 1.396l1.183-1.238c-1.203-1.078-2.979-1.8-4.404-1.8-1.425 0-1.594.6-3.36.6-1.766 0-2.28-.6-3.36-.6A5.041 5.041 0 000 16.44v.96a1.8 1.8 0 001.8 1.8H12v-1.8H1.8v-.96a3.246 3.246 0 013.24-3.24z"}})]),_c('g',{attrs:{"fill":"#969798","fill-rule":"nonzero"}},[_c('use',{attrs:{"transform":"translate(0 2)","xlink:href":"#a"}}),_c('path',{attrs:{"d":"M13.259 19.848l-.255 2.288a.597.597 0 00.66.66l2.283-.255 5.172-5.172-2.69-2.689-5.17 5.168zm10.279-6.165l-1.422-1.421a.899.899 0 00-1.267 0l-1.568 1.567 2.693 2.689 1.567-1.568a.902.902 0 00-.003-1.267z"}})])])
          )
        }
      }
    